import { render, staticRenderFns } from "./insurance_detail_pc.vue?vue&type=template&id=5cb76714&scoped=true&"
import script from "./insurance_detail_pc.vue?vue&type=script&lang=js&"
export * from "./insurance_detail_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb76714",
  null
  
)

export default component.exports